import React, { useEffect } from 'react';
import "../register.css";
import { AuthContext } from "../../AuthContext";
import { EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { Tab, Table } from 'react-bootstrap';
import { getAPI } from '../GdacsAPI';
import { useViewPort } from '../Hooks/useViewPort';

const TableRowAddress = (props) => {
    const authContext = React.useContext(AuthContext);
    const params = props.params;
    const [addresses, setAddresses] = React.useState(params?.addresses.sort((a, b) => a.idServiceType > b.idServiceType ? 1 : -1).map((a, i) => ({ ...a, id: i })) ?? []);
    const { width } = useViewPort();
    const breakpoint = 520;

    return (
        <>
            {width > breakpoint &&
                <Table id="recapUser" className="table_recapUser" >

                    <thead>
                        <th style={{ width: "50%" }}>Channel</th>
                        <th style={{ width: "50%" }}>Address</th>
                    </thead>
                    <tbody>
                        {
                            addresses.map((address) => {
                                return <tr><AddressRow address={address} /></tr>
                            })
                        }
                    </tbody>
                </Table>
            }
            {width < breakpoint &&
                <Table id="recapUser" className="table_recapUser" >
                    <thead>
                        <th style={{ width: "40%" }}>Channel</th>
                        <th style={{ width: "60%" }}>Address</th>
                    </thead>
                    <tbody>
                        {
                            addresses.map((address) => {
                                return <tr><AddressRow address={address} /></tr>
                            })
                        }
                    </tbody>
                </Table>
            }
        </>
    )
}

const AddressRow = (props) => {
    const [servicestypes, setServicesTypes] = React.useState([]);

    async function GetServicesTypes() {
        var url = getAPI() + `api/register/Definition/servicetype/`;
        const response = await fetch(url);
        if (!response.ok) {
            setServicesTypes([]);
            return;
        }
        const servicesTypesData = await response.json();
        if (servicesTypesData) {
            setServicesTypes(servicesTypesData);
        }
    }

    React.useEffect(() => {
        GetServicesTypes();
    }, []);

    return (
        <>
            {servicestypes.filter(item => item.idServiceType === props.address.idServiceType).map(types => (
                <td style={{ textAlign: "center" }} key={types.idServiceType}>
                    {types.idServiceType === 1 ?
                        <EnvelopeFill color="#0099CC" size={18} />
                        : types.idServiceType === 3 ? <Telephone color="#0099CC" size={18} />
                            : <Phone color="#0099CC" size={18} />
                    }
                </td>
            ))}
            <td>{props.address.idServiceType !== 10 ? props.address.addressValue :
                (props.address.idServiceType === 10 && props.address.addressValue === "") ? <div style={{ color: "red" }}>Not Actived, set on App</div> : <div style={{ color: "#27ac27" }}>Active</div>}</td>
        </>
    )
}

export { TableRowAddress };